import {html, css, unsafeCSS} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';

import {hoverInfo, widgetButton} from '../../css/styleSets';
import colorIcon from '../../../icons/colorIcon';
import custom from '../../../icons/custom';
import StandardColourOfChoice from '../../../icons/StandardColourOfChoice';
import {SpcChoiceValue} from './spcChoiceValue';
import {pimText} from '../../util/values';

@customElement('spc-choice-value-color')
export class SpcChoiceValueColor extends SpcChoiceValue {

	static styles = [
		widgetButton,
		hoverInfo,
		css`
			:host {
				flex-grow: 1;
				display: contents;
			}

			.item {
				position: relative;
				margin-bottom: 0;
				width: auto;
				flex-grow: 1;
			}

			.hidden {
				display: none;
			}

			.item button {
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.disabled button {
				color: var(--color-widget-border);
			}
			.disabled button svg {
				opacity: 0.2;
			}

			.disabled button:hover {
				color: var(--color-widget-border);
			}
			button svg {
				fill: currentColor;
				width: 16px;
				height: 16px;
			}

		`];

	getInfoText() {
		const short = pimText(this.lang, this.attributeId.localId, 'FV.S', this.spcConfiguration, this.translations, this.value.id);
		const long = pimText(this.lang, this.attributeId.localId, 'FV.L', this.spcConfiguration, this.translations, this.value.id);
		const info = long || short || '';
		return short + (!info.includes('[') ? ', ' + info : '');
	}

	render() {
		if (!this.value) return null;
		const hexColor = this.productData?.displayColour ?? '#0F0';
		let icon = colorIcon;
		switch (this.productData?.displayColour) {
			case 'custom':
				icon = custom;
				break;
			case 'StandardColourOfChoice':
				icon = StandardColourOfChoice;
				break;
		}
		return html`
			<div class="item ${classMap({
				selected: this.isIncluded(),
				disabled: !this.isAllowed(),
				fixed: !this.canBeExcluded(),
				hidden: !this.isVisible()
			})}">
				<button @click="${this.makeDecision}" style="color: ${unsafeCSS(hexColor)}">
					${icon}
				</button>
				${when(this.getInfoText() !== '', () => html`
					<div class="hoverinfo">
						<div class="content">${this.getInfoText()}</div>
					</div>
				`)}
			</div>
		`;
	}
}
